import { SearchCandidateVectorCandidateProfile } from 'modules/candidate-profile/types';
import { useSourcingInternalCandidateProfileDuplicateCheck } from './useSourcingInternalCandidateProfileDuplicateCheck';
import { mapCandidateProfileDataToTableColumns } from 'modules/candidate-profile/tables/maps/mapCandidateProfileDataToTableColumns';
import {
  CandidateProfileListProps,
  CandidateProfileListType
} from 'modules/candidate-profile/types/CandidateProfileListProps';
import { getCandidateBatchFromCandidateProfileListProps } from 'modules/candidate-profile/utils/getCandidateBatchFromCandidateProfileListProps';

type UseCandidateProfileDuplicateCheckForTableProps = {
  candidateProfileListProps: CandidateProfileListProps;
  candidateProfiles: SearchCandidateVectorCandidateProfile[];
};

const getTargetTalentPoolId = (
  candidateProfileListProps: CandidateProfileListProps
): string | null => {
  if (
    candidateProfileListProps.type ===
    CandidateProfileListType.ADD_CANDIDATES_TO_TALENT_POOL
  ) {
    return candidateProfileListProps.talentPoolId;
  }
  return null;
};

export const useCandidateProfileDuplicateCheckForTable = ({
  candidateProfileListProps,
  candidateProfiles
}: UseCandidateProfileDuplicateCheckForTableProps) => {
  const candidateBatchId = getCandidateBatchFromCandidateProfileListProps(
    candidateProfileListProps
  );
  const targetTalentPoolId = getTargetTalentPoolId(candidateProfileListProps);

  const {
    isLoading: isDuplicateCheckLoading,
    duplicateCandidateProfileResults
  } = useSourcingInternalCandidateProfileDuplicateCheck({
    candidateProfileIds: candidateProfiles.map(
      (profile) => profile.candidate_profile_id
    ),
    candidateBatchId: candidateBatchId ?? null
  });

  const mappedColumnData = mapCandidateProfileDataToTableColumns({
    data: candidateProfiles,
    duplicateCandidateProfileResults,
    targetTalentPoolId
  });

  return {
    isDuplicateCheckLoading,
    candidates: mappedColumnData
  };
};
